<template>
  <div class="the-sign-in">
    <div class="title-wrap">
      <!-- <div class="title-item">标题</div> -->
      <div class="title-item">{{ systemName }} Portal</div>
    </div>

    <a-form :form="form" @submit="submit" class="sign-in-form">
      <a-form-item :colon="false" :label="$t('user.account')">
        <a-input
          :placeholder="$t('user.account')"
          v-decorator="[
            'member',
            {
              rules: [
                {
                  required: true,
                  message: $t('public.pleaseFill', {
                    content: $t('user.account')
                  })
                }
              ]
            }
          ]"
        >
        </a-input>
      </a-form-item>
      <a-form-item :colon="false" :label="`${$t('user.password')}`">
        <a-input
          :placeholder="$t('user.password')"
          type="password"
          v-decorator="[
            'password',
            {
              rules: [
                {
                  required: true,
                  message: $t('public.pleaseFill', {
                    content: $t('user.password')
                  })
                }
              ]
            }
          ]"
        >
        </a-input>
        <div style="position: absolute; right: -10px; top: 15px;">
          <a-button type="link" @click="passwordReset">
            找回密码
          </a-button>
        </div>
      </a-form-item>
      <a-form-item>
        <a-button block type="primary" html-type="submit">
          {{ $t('user.signIn') }}
        </a-button>
      </a-form-item>
    </a-form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      form: this.$form.createForm(this)
    }
  },

  computed: {
    ...mapGetters(['systemName', 'indexRouter'])
  },

  watch: {
    // 更新form检测信息的翻译
    '$i18n.locale'() {
      this.$nextTick(() => {
        const fieldsError = this.form.getFieldsError()
        let fieldsErrorName = []

        for (const key in fieldsError) {
          if (fieldsError[key]) {
            fieldsErrorName.push(key)
          }
        }

        if (fieldsErrorName.length > 0) {
          this.form.validateFields(fieldsErrorName, { force: true }, () => {})
        }
      })
    }
  },

  methods: {
    submit(e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          this.staffLogin({ member: values.member, password: values.password })
        }
      })
    },

    staffLogin(loginData) {
      this.$http(this.$api.LOGIN, {
        account: loginData.member,
        password: loginData.password
      }).then(r => {
        this.$message.success(this.$t('user.signInSuccess'))
        const date = new Date()
        this.$cookie.set('token', date.getTime(), { expires: 1 })

        let tempData = r.data.permissions.find(Element => {
          return Element.id == 1
        })

        for (let itemJ of tempData.childNodeList) {
          if (itemJ.name !== '所有学习中心') {
            r.data.permissions.push(itemJ)
          }
        }
        for (let itemj of r.data.permissions) {
          if (itemj.name == '所有学习中心') {
            itemj.childNodeList.splice(1, itemj.childNodeList.length - 1)
          }
        }
        localStorage.setItem('CSVPAUserInfo', JSON.stringify(r.data))
        this.$router.push('/')
      })
    },

    passwordReset() {
      this.$store.commit('SET_HANDLETYPE', 'the-password-reset')
    }
  }
}
</script>

<style lang="less" scoped>
@import '../../style/variable.less';

.the-sign-in {
  width: 400px;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.2);
  border-radius: 2px;
  overflow: hidden;
  background-color: #fff;
  margin-top: -30px;
  .title-wrap {
    background-color: @themeColor;
    padding: 35px 25px 25px;
    color: #fff;
    .title-item {
      font-size: 24px;
      line-height: 1;
      // margin-top: 10px;
    }
  }
  .sign-in-form {
    margin-top: 20px;
    padding: 0 25px 15px;
  }
}
</style>

<style lang="less">
.sign-in-form {
  .ant-form-item-label {
    line-height: 1;
  }
}
</style>
